<template>
  <el-dialog
    v-bind="$attrs"
    :title="title"
    :width="$attrs.width"
    :visible="is_visible"
    :close-on-click-modal="false"
    @close="
      () => {
        if (cancelCallbackOnClose) $emit('cancel-callback');
      }
    "
    class="dialog"
  >
    <div>
      <p class="dialog__text" v-html="text"></p>
    </div>
    <div slot="footer" v-loading="loading">
      <div class="footer footer--auto-width">
        <Button
          buttonSize="big"
          :buttonColor="buttonCancelColor"
          :buttonText="buttonCancelText"
          @click="$emit('cancel-callback')"
          class="footer__button-cancel"
        />
        <Button
          buttonSize="big"
          :buttonColor="buttonOkColor"
          :buttonText="buttonOkText"
          @click="$emit('ok-callback')"
          class="footer__button-ok"
        />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui';
import { store } from '@/store';
import Button from 'Elements/Button/Button';
export default {
  inheritAttrs: false,
  props: {
    cancelCallbackOnClose: {
      type: Boolean,
      default: true
    },
    is_visible: {
      type: Boolean
    },
    title: {
      type: String
    },
    text: String,
    buttonOkColor: {
      type: String,
      default: 'darkBlue'
    },
    buttonOkText: {
      type: String,
      default: 'Ok'
    },
    buttonCancelColor: {
      type: String,
      default: 'blue'
    },
    buttonCancelText: {
      type: String,
      default: 'Отмена'
    }
  },
  computed: {
    loading() {
      return store.state.dialog.loading || false;
    }
  },
  components: { 'el-dialog': Dialog, Button }
};
</script>
<style lang="scss" scoped>
.dialog {
  &__text {
    font-size: 16px !important;
  }

  & ::v-deep .el-loading-mask {
    top: -2px;
    right: -2px;
    bottom: -2px;
    left: -2px;
  }
}
</style>
